import { z } from "zod";

import { intIdCodec } from "@/codecs/intId";

export const userIdSchema = z.string().brand<"UserId">();
export type UserId = z.infer<typeof userIdSchema>;

export const coreUserIdCodec = intIdCodec(userIdSchema);
